"use strict";
/* eslint-disable finley/variable-length */
/* eslint-disable no-restricted-syntax */
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineBuffers = exports.fromBase64 = exports.toBase64 = exports.fromArrayBuffer = exports.toString = exports.fromString = void 0;
const fromString = (str) => {
    const encoder = new TextEncoder();
    return encoder.encode(str);
};
exports.fromString = fromString;
const toString = (buffer) => {
    const decoder = new TextDecoder('utf-8');
    return decoder.decode(buffer);
};
exports.toString = toString;
const fromArrayBuffer = (buffer) => {
    return new Uint8Array(buffer);
};
exports.fromArrayBuffer = fromArrayBuffer;
const toBase64 = (buffer) => {
    let binary = '';
    const chunkSize = 8192; // process in chunks of 8192 bytes
    for (let i = 0; i < buffer.length; i += chunkSize) {
        const chunk = buffer.subarray(i, i + chunkSize);
        binary += String.fromCharCode.apply(null, Array.from(chunk));
    }
    return btoa(binary);
};
exports.toBase64 = toBase64;
const fromBase64 = (str) => {
    return Uint8Array.from(atob(str), (c) => c.charCodeAt(0));
};
exports.fromBase64 = fromBase64;
const combineBuffers = (finleyBuffers) => {
    const byteLength = finleyBuffers.reduce((sum, item) => sum + item.byteLength, 0);
    const combinedBuffer = new Uint8Array(byteLength);
    let offset = 0;
    for (const item of finleyBuffers) {
        combinedBuffer.set(item, offset);
        offset += item.byteLength;
    }
    return combinedBuffer;
};
exports.combineBuffers = combineBuffers;
//# sourceMappingURL=finleyBuffer.js.map